import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

export type SideMenuState = {
  isSideMenuOpen: boolean;
};

const initState: SideMenuState = {
  isSideMenuOpen: false,
};

export const useSideMenu = createStore({
  name: 'side-menu',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setSideMenu: handler('isSideMenuOpen'),
  };
});
